import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export const AbvMediShaLineChart = ({ startPeriod, endPeriod, prodIds, stateIds }) => {
  const rsrc = useRsrc();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const buildRegressionValues = (yValues) => {
    const n = yValues.length;
    if (!n) return [];

    let sumX = 0;
    let sumY = 0;
    let sumXY = 0;
    let sumXX = 0;

    for (let i = 0; i < n; i += 1) {
      const x = i;
      const y = yValues[i];
      sumX += x;
      sumY += y;
      sumXY += x * y;
      sumXX += x * x;
    }

    const denom = (n * sumXX) - (sumX * sumX);
    if (denom === 0) return yValues.map(() => yValues[0] ?? 0);

    const slope = ((n * sumXY) - (sumX * sumY)) / denom;
    const intercept = (sumY - (slope * sumX)) / n;

    return yValues.map((_, i) => (slope * i) + intercept);
  };

  useEffect(() => {
    setLoading(true);
    setData(null); // reset so old chart doesn't flash while loading
    const reqParam = { startPeriod, endPeriod, prodIds, stateIds };
    rsrc.data('gtn', 'MEDI_SHA_LINE_CHART_DATA_PLUGIN', reqParam)
      .then((resp) => { setData(resp); })
      .finally(() => { setLoading(false); });
  }, [startPeriod, endPeriod, prodIds, stateIds]);

  if (loading) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress />
        <Typography mt={2}>Loading...</Typography>
      </Box>
    );
  }

  if (!data) return null;

  const periodCodes = Object.keys(data || {}).sort();
  if (!periodCodes.length) return null;

  const values = periodCodes.map((periodCode) => Number(data[periodCode]) || 0);
  const regressionValues = buildRegressionValues(values);

  const chartData = {
    categories: periodCodes,
    series: [
      {
        label: 'All States',
        values,
        type: 'line',
      },
      {
        label: 'Trend',
        values: regressionValues,
        type: 'line',
        dashStyle: 'ShortDot',
      },
    ],
  };

  return (
    <CartesianChart
      data={chartData}
      legend="top"
      markers={true}
      yLabel="Sales Amount"
    />
  );
};
